import Axios from '@/api/http'

// 获取图标路径
export function getrencenticons (query) {
  return Axios({
    method: 'post',
    url: '/api/getrencenticons',
    data: query,
    withCredentials: false
  })
}

// 获取图标路径
export function getsvgicon (query) {
  return Axios({
    method: 'get',
    url: '/images/getsvgicon',
    params: query,
    withCredentials: false
  })
}

// 新增上传图标
export function addficon (data) {
  return Axios({
    method: 'post',
    url: '/api/addficon',
    data,
    withCredentials: false
  })
}
// 获取自定义上传图标列表
export function getficonlist (data) {
  return Axios({
    method: 'post',
    url: '/api/getficonlist',
    data,
    withCredentials: false
  })
}
export function deleteficon (data) {
  return Axios({
    method: 'post',
    url: '/api/deleteficon',
    data,
    withCredentials: false
  })
}